/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { createRole } from '../fn/roles/create-role';
import { CreateRole$Params } from '../fn/roles/create-role';
import { deleteRole } from '../fn/roles/delete-role';
import { DeleteRole$Params } from '../fn/roles/delete-role';
import { getRole } from '../fn/roles/get-role';
import { GetRole$Params } from '../fn/roles/get-role';
import { listAddableRoles } from '../fn/roles/list-addable-roles';
import { ListAddableRoles$Params } from '../fn/roles/list-addable-roles';
import { listRoles } from '../fn/roles/list-roles';
import { ListRoles$Params } from '../fn/roles/list-roles';
import { RoleDto } from '../models/role-dto';
import { RoleDtoPage } from '../models/role-dto-page';
import { updateRole } from '../fn/roles/update-role';
import { UpdateRole$Params } from '../fn/roles/update-role';

@Injectable({ providedIn: 'root' })
export class RolesApi extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `listRoles()` */
  static readonly ListRolesPath = '/v0/roles';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `listRoles()` instead.
   *
   * This method doesn't expect any request body.
   */
  listRoles$Response(params?: ListRoles$Params, context?: HttpContext): Observable<StrictHttpResponse<RoleDtoPage>> {
    return listRoles(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `listRoles$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  listRoles(params?: ListRoles$Params, context?: HttpContext): Observable<RoleDtoPage> {
    return this.listRoles$Response(params, context).pipe(
      map((r: StrictHttpResponse<RoleDtoPage>): RoleDtoPage => r.body)
    );
  }

  /** Path part for operation `getRole()` */
  static readonly GetRolePath = '/v0/roles/{id}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getRole()` instead.
   *
   * This method doesn't expect any request body.
   */
  getRole$Response(params: GetRole$Params, context?: HttpContext): Observable<StrictHttpResponse<RoleDto>> {
    return getRole(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getRole$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getRole(params: GetRole$Params, context?: HttpContext): Observable<RoleDto> {
    return this.getRole$Response(params, context).pipe(
      map((r: StrictHttpResponse<RoleDto>): RoleDto => r.body)
    );
  }

  /** Path part for operation `updateRole()` */
  static readonly UpdateRolePath = '/v0/roles/{id}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `updateRole()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateRole$Response(params: UpdateRole$Params, context?: HttpContext): Observable<StrictHttpResponse<RoleDto>> {
    return updateRole(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `updateRole$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateRole(params: UpdateRole$Params, context?: HttpContext): Observable<RoleDto> {
    return this.updateRole$Response(params, context).pipe(
      map((r: StrictHttpResponse<RoleDto>): RoleDto => r.body)
    );
  }

  /** Path part for operation `createRole()` */
  static readonly CreateRolePath = '/v0/roles/{id}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `createRole()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  createRole$Response(params: CreateRole$Params, context?: HttpContext): Observable<StrictHttpResponse<RoleDto>> {
    return createRole(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `createRole$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  createRole(params: CreateRole$Params, context?: HttpContext): Observable<RoleDto> {
    return this.createRole$Response(params, context).pipe(
      map((r: StrictHttpResponse<RoleDto>): RoleDto => r.body)
    );
  }

  /** Path part for operation `deleteRole()` */
  static readonly DeleteRolePath = '/v0/roles/{id}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `deleteRole()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteRole$Response(params: DeleteRole$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return deleteRole(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `deleteRole$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteRole(params: DeleteRole$Params, context?: HttpContext): Observable<void> {
    return this.deleteRole$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `listAddableRoles()` */
  static readonly ListAddableRolesPath = '/v0/roles/addable';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `listAddableRoles()` instead.
   *
   * This method doesn't expect any request body.
   */
  listAddableRoles$Response(params: ListAddableRoles$Params, context?: HttpContext): Observable<StrictHttpResponse<RoleDtoPage>> {
    return listAddableRoles(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `listAddableRoles$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  listAddableRoles(params: ListAddableRoles$Params, context?: HttpContext): Observable<RoleDtoPage> {
    return this.listAddableRoles$Response(params, context).pipe(
      map((r: StrictHttpResponse<RoleDtoPage>): RoleDtoPage => r.body)
    );
  }

}
